import React, { useEffect, useRef, useState } from "react";
import { Cookies } from "react-cookie";
import axios from "axios";
import ExcelJS from "exceljs";
import Loading from "../Loading";

const DownloadRefillerSheets = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    // const baseUrl = "http://localhost:3000";
    const cookies = new Cookies();
    const token = cookies.get("JWTcookie");
    const [refillerList, setRefillerList] = useState([]);
    const [refillerName, setRefillerName] = useState("");
    const [refillerID, setRefillerID] = useState();
    const [filteredRefillerList, setFilteredRefillerList] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
        RefillerNameList()
    }, [])

    const RefillerNameList = async () => {
        try {
            const res = await axios.get(`${baseUrl}/api/User/DataList?role=Refiller`, {
                headers: { Authorization: "Bearer " + token },
            });
            const data = res.data;
            setRefillerList(data.data);
            setFilteredRefillerList(data.data);
        } catch (error) {
            console.error('Error fetching sales data:', error);
        }
    };

    const handleSearch = (event) => {
        const value = event.target.value;
        setIsVisible(true)
        setRefillerName(value);
        setRefillerID();
        const filtered = refillerList.filter(item =>
            item.first_name.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredRefillerList(filtered);
    }

    const getDate = () => {
        const date = new Date();
        let currentDay = String(date.getDate()).padStart(2, '0');
        let currentMonth = String(date.getMonth() + 1).padStart(2, "0");
        let currentYear = date.getFullYear();
        // we will display the date as DD-MM-YYYY 
        return `${currentDay}-${currentMonth}-${currentYear}`;

    }

    const generateAndDownloadExcel = async (salesData, name) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(`${name}`);

        let currentRow = 1; // Start at row 2 to leave space for headers

        for (let i = 0; i < salesData.length; i += 2) {
            const machine1 = salesData[i];
            const machine2 = i + 1 < salesData.length ? salesData[i + 1] : null;

            // Set the machine names as merged cells with styling
            let headings = ["Slot", "Product Name", "Cl.St", "Qty"];
            const machineStartRow = currentRow;
            if (machine1) {
                worksheet.mergeCells(currentRow, 1, currentRow, 4);
                const mergedCell1 = worksheet.getCell(currentRow, 1);
                mergedCell1.value = `Machine: ${machine1.machineName}`;
                mergedCell1.font = { bold: true };

                setCellBorders(mergedCell1);
            }

            if (machine2) {
                headings = [
                    ...headings,
                    "Slot",
                    "Product Name",
                    "Cl.St",
                    "Qty"
                ];
                worksheet.mergeCells(currentRow, 5, currentRow, 8);
                const mergedCell2 = worksheet.getCell(currentRow, 5);
                mergedCell2.value = `Machine: ${machine2.machineName}`;
                mergedCell2.font = { bold: true };

                setCellBorders(mergedCell2);
            }

            currentRow++;

            // Add headings for Slot, Product Name, Closing Stock, and Quantity

            worksheet.getRow(currentRow).values = headings;
            worksheet.getRow(currentRow).font = { bold: true };

            setCellBorders(worksheet.getRow(currentRow));

            currentRow++;

            // Populate product data for the machines
            const maxSlots = Math.max(
                machine1 ? machine1.stock.length : 0,
                machine2 ? machine2.stock.length : 0
            );

            for (let j = 0; j < maxSlots; j++) {
                const item1 = machine1 ? machine1.stock[j] || {} : {};
                const item2 = machine2 ? machine2.stock[j] || {} : {};

                if (
                    item1.slot ||
                    item1.product ||
                    item1.closingStock ||
                    item1.quantity
                ) {
                    worksheet.getCell(currentRow, 1).value = item1.slot || "";
                    worksheet.getCell(currentRow, 2).value = item1.product || "";
                    worksheet.getCell(currentRow, 3).value =
                        item1.closingStock !== undefined
                            ? item1.closingStock
                            : "";
                    worksheet.getCell(currentRow, 4).value =
                        item1.quantity !== undefined ? item1.quantity.toString() : "";
                }

                if (
                    item2.slot ||
                    item2.product ||
                    item2.closingStock ||
                    item2.quantity
                ) {
                    worksheet.getCell(currentRow, 5).value = item2.slot || "";
                    worksheet.getCell(currentRow, 6).value = item2.product || "";
                    worksheet.getCell(currentRow, 7).value =
                        item2.closingStock !== undefined
                            ? item2.closingStock
                            : "";
                    worksheet.getCell(currentRow, 8).value =
                        item2.quantity !== undefined ? item2.quantity.toString() : "";
                }

                setCellBorders(worksheet.getRow(currentRow));

                currentRow++;
            }

            // Apply borders to the machine's section
            if (machine1) {
                setCellBorders(worksheet.getRow(machineStartRow));
                setCellBorders(worksheet.getRow(currentRow - 1));
            }
        }

        // Create a buffer from the workbook
        const buffer = await workbook.xlsx.writeBuffer();

        // Create a Blob from the buffer and initiate a download
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download =`${refillerName} ${getDate()} refill sheet.xlsx` ;
        a.click();
        URL.revokeObjectURL(url);
    };
    // Helper function to set cell borders conditionally
    const setCellBorders = (cell) => {
        cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
        };
    };

    const handleSubmit = async () => {
        // console.log('refillerID: ', refillerID);

        if (!refillerID) {
            return alert("Please select refiller first")
        }
        try {
            setLoading(true)
            const res = await axios.get(`${baseUrl}/api/refillSheet?refiller=${refillerID}`, {
                headers: { Authorization: "Bearer " + token },
            });
            const data = res.data;
            // console.log('data: ', data.data);
            // generateAndDownloadExcel(data.data); // direct call here this function which is generate the excel file
            const SordetData = data.data.map((item) => (
                {
                    ...item,
                    stock: item.stock.sort((a, b) => a.slot.localeCompare(b.slot))
                }
            ))
            // console.log('SordetData: ', SordetData);
            generateAndDownloadExcel(SordetData);
            setRefillerID(); // refiller id empty after download excel sheet
            setRefillerName(""); // refiller Name (in input box) empty after download excel sheet
            setLoading(false)

        } catch (error) {
            console.error('Error fetching sales data:', error);
            setLoading(false)
        }
    }
    // console.log("refillerList", refillerList);
    return (
        <div>
            {!isLoading ?
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <div style={{ backgroundColor: "black", color: "white", padding: "7px", marginBottom: "20px" }}>
                        Choose Refiller to Download Sheets
                    </div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        position: "relative"
                    }}>
                        <input
                            ref={inputRef}
                            className="td_input"
                            style={{ width: "20%", padding: "0px" }}
                            type="text"
                            placeholder='Choose Refiller'
                            value={refillerName}
                            onClick={() => setIsVisible(!isVisible)}
                            onChange={(e) => handleSearch(e)}
                        />
                        {isVisible &&
                            <div style={{
                                height: "100vh",
                                width: "100vw",
                                backgroundColor: "transparent",
                                position: "absolute",
                                top: "0%",
                                left: "0%",
                                zIndex: "2"
                            }}
                                onClick={() => setIsVisible(false)}
                            >
                                <div
                                    style={{
                                        minWidth: "200px",
                                        margin: "auto",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        backgroundColor: "white",
                                        display: "flex",
                                        flexDirection: "column",
                                        padding: "3px 3px",
                                        boxShadow: "rgba(0, 0, 0, 0.4) 0px 30px 90px",
                                        position: "absolute",
                                        top: "9%",
                                        left: "0%",
                                        zIndex: "2"
                                    }}
                                >
                                    {filteredRefillerList.map((item, index) => (
                                        <div
                                            key={item._id}
                                            onClick={() => {
                                                setIsVisible(false);
                                                setRefillerName(`${item.first_name} ${item.last_name}`);
                                                setRefillerID(item.user_id);
                                            }}
                                            style={{
                                                cursor: "pointer",
                                                padding: "3px 10px 0px",
                                                boxShadow: "rgba(0, 0, 0, 0.45) 0px 25px 20px -20px",
                                                borderBottom: "1px solid gray",
                                            }}
                                        >
                                            {item.first_name} {item.last_name}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }
                        {/* style={{ display: "block", margin: "auto", marginTop: "10px" }} */}
                        <button type="text" className="submit-btn" onClick={handleSubmit}>Download</button>
                    </div>
                </div>
                :
                <Loading />
            }
        </div >
    );
}

// without border
// const DownloadRefillerSheets = () => {
//     const baseUrl = 'https://officejeeves.com';
//     const cookies = new Cookies();
//     const token = cookies.get("JWTcookie");
//     const [salesData, setSalesData] = useState([]);
//     const RefillerMachinesList = async () => {
//         try {
//             const res = await axios.get(`${baseUrl}/api/refillSheet?refiller=REF001`, {
//                 headers: { Authorization: "Bearer " + token },
//             });
//             const data = res.data;
//             console.log('data: ', data);
//             setSalesData(data.data);
//         } catch (error) {
//             console.error('Error fetching sales data:', error);
//         }
//     };
//     const RefillerList = async () => {
//         try {
//             const res = await axios.get(`${baseUrl}/api/User/DataList?role=Refiller`, {
//                 headers: { Authorization: "Bearer " + token },
//             });
//             const data = res.data;
//             console.log('RefillerList: ', data);
//             // setSalesData(data.data);
//         } catch (error) {
//             console.error('Error fetching sales data:', error);
//         }
//     };

//     useEffect(() => {
//         // RefillerList()
//         RefillerMachinesList()
//     }, [])


//     console.log('RefillerMachinesList: ', salesData);

//     // // litle bit correct
//     const downloadSalesData = () => {
//         let csvContent = "data:text/csv;charset=utf-8,";

//         for (let i = 0; i < salesData.length; i += 2) {
//             console.log('salesData: ', salesData);
//             const leftMachine = salesData[i].machineName;
//             const rightMachine = i + 1 < salesData.length ? salesData[i + 1].machineName : "";

//             // Header for each machine set
//             csvContent += rightMachine ? `Machine: ${leftMachine},,,,Machine: ${rightMachine}\n` : `Machine: ${leftMachine}\n`
//             csvContent += rightMachine ? "Slot,Product Name,C.Stock,Qty,Slot,Product Name,C.Stock,Quantity\n" : `Slot,Product Name,C.Stock,Qty\n`

//             const maxSlots = Math.max(salesData[i].stock.length, (i + 1 < salesData.length ? salesData[i + 1].stock.length : 0));

//             for (let j = 0; j < maxSlots; j++) {
//                 const leftSlot = salesData[i].stock[j] || {};
//                 const rightSlot = (i + 1 < salesData.length ? salesData[i + 1].stock[j] : {}) || {};

//                 csvContent += `${leftSlot.slot || ""},${leftSlot.product || ""},${leftSlot.product ? leftSlot.currentStock || 0 : ""},,`;
//                 csvContent += `${rightSlot.slot || ""},${rightSlot.product || ""},${rightSlot.product ? rightSlot.currentStock || 0 : ""}\n`;
//             }
//             csvContent += "\n"; // Separate machine sets
//         }

//         const encodedUri = encodeURI(csvContent);
//         const link = document.createElement("a");
//         link.setAttribute("href", encodedUri);
//         link.setAttribute("download", "sales_report_combined.csv");
//         document.body.appendChild(link);
//         link.click();
//     };


//     return (
//         <div>
//             <button onClick={downloadSalesData}>Download Refiller Sheets</button>
//         </div>
//     );
// };
export default DownloadRefillerSheets;